(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("testItemDetailsReportList", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/reports/testItemDetailsReportListView.html",
            controller: ["authService", "DTOptionsBuilder", "$scope", "$state", "$timeout", "$translate", "$localStorage", TestItemDetailsReportListCtrl],
            controllerAs: "vm"
        };
        function TestItemDetailsReportListCtrl(authService, DTOptionsBuilder, $scope, $state, $timeout, $translate, $localStorage) {
            var vm = this;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtOptions = {};
            vm.dtInstance = {
                reloadData: function () { }
            };
            vm.filter = {
                number: {
                    name: "examNumber",
                    label: "common.filters.examNumber",
                    enabled: true,
                    value: "",
                    type: "text"
                },
                name: {
                    name: "exam",
                    label: "common.filters.exam",
                    enabled: true,
                    value: "",
                    type: "text"
                }
            };
            vm.dtColumns = [
                {
                    "data": "number",
                    "class": "text-center",
                    "title": $translate.instant("common.lists.examNumber"),
                    "width": "20%"
                },
                {
                    "data": "name",
                    "title": $translate.instant("common.lists.exam")
                }
            ];
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withOption("ajax", {
                url: "/api/reports/test-item-details",
                error: function (error) {
                    if (error.status === 401) {
                        $state.go("main.signIn");
                    }
                    else if (error.status === 403) {
                        $state.go("main.accessDenied");
                    }
                },
                type: "GET",
                headers: {
                    Authorization: "Bearer " + authService.getToken(),
                    CurrentLocalizationId: $localStorage.currentLocalizationId
                },
                data: function (data) {
                    data.columns[0].search.value = vm.filter.number.enabled ? vm.filter.number.value : "";
                    data.columns[1].search.value = vm.filter.name.enabled ? vm.filter.name.value : "";
                }
            })
                .withDataProp("data")
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("serverSide", true)
                .withOption("stateDuration", -1)
                .withPaginationType("full_numbers")
                .withOption("rowCallback", rowCallback)
                .withBootstrap();
            vm.onFilter = function () {
                vm.dtInstance.reloadData();
            };
            function rowClickHandler(row) {
                $state.go("main.reporting.testItemDetails", { number: row.number });
            }
            function rowCallback(nRow, aData) {
                // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
                $("td:not(.control)", nRow).unbind("click");
                $timeout(function () {
                    $("td:not(.control)", nRow).bind("click", function () {
                        $scope.$apply(function () {
                            rowClickHandler(aData);
                        });
                    });
                });
                return nRow;
            }
        }
    });
}());
